"use client";

import { c as _c } from "react/compiler-runtime";
import { useChatbotVisibility } from "./chatbot-experiment";
import { LazyChatBotModal } from "./lazy-chat-bot-modal";
export const ChatBotExperimentModalHost = () => {
  const $ = _c(1);
  const visible = useChatbotVisibility();
  if (visible !== true) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <LazyChatBotModal />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};